/* eslint-disable object-shorthand */
import { useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { ApiSuccessResponse } from '../../../types/AppTypes';
import { TextWrap as Text, View, HelperText, styles as sc, TextInput } from '../../../components/Themed';
import { RootStackScreenProps } from '../../../navigation/navigationTypes';
import SnapCalorieSitePage from '../../../components/SnapCalorieSitePage';
import TextButton from '../../../components/elements/TextButton';
import apiConst from '../../../constants/Api';

export default function VerifyReferralAccount({ navigation, route }: RootStackScreenProps<'ReferralVerification'>) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [email, setEmail] = useState(route.params ? route.params.email ?? route.params.email : 'No Email');
  const [verificationCode, setVerificationCode] = useState('');
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState('');

  const onChangeVerificationCode = (newText: string) => setVerificationCode(newText);
  const hasVerificationErrors = () => {
    return verificationCode.length < 6;
  };

  const handleResendCode = () => {
    const backendUrl = `${apiConst.backendUrl}/auth/cognito/resend-confirmation`;
    const resendBody = {
      email: email,
    };
    fetch(backendUrl, {
      method: 'POST',
      body: new URLSearchParams(resendBody),
    })
      .then((resp) => {
        resp.json().then((jsonResp) => {
          if (resp.status === 200) {
            console.log(`New confirmation requested`);
          } else {
            // eslint-disable-next-line max-len
            console.error(
              `An error occurred requesting a new verification code: ${(jsonResp as ApiSuccessResponse).message}`
            );
            setFormErrorMessage((jsonResp as ApiSuccessResponse).message!);
          }
        });
      })
      .catch((err) => {
        setFormErrorMessage(err);
      });
  };

  const handleSubmit = () => {
    if (hasVerificationErrors()) {
      setShowFormErrors(true);
    } else {
      const backendUrl = `${apiConst.backendUrl}/auth/cognito/confirm`;
      const verifyBody = {
        email: email,
        code: verificationCode,
      };
      fetch(backendUrl, {
        method: 'POST',
        body: new URLSearchParams(verifyBody),
      })
        .then((resp) => {
          resp.json().then((jsonResp) => {
            if (resp.status === 200) {
              console.log(`Email verified`);
              navigation.navigate('DownloadApp');
            } else {
              console.error(`An error occurred during email verification: ${(jsonResp as ApiSuccessResponse).message}`);
              setFormErrorMessage((jsonResp as ApiSuccessResponse).message!);
            }
          });
        })
        .catch((err) => {
          setFormErrorMessage(err);
        });
    }
  };

  const windowDimensions = useWindowDimensions();
  const maxWidth = Math.min(windowDimensions.width, 350);
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View>
        <Text style={[sc.focusText, { fontSize: 20, textAlign: 'center', maxWidth: maxWidth }]}>
          Enter the 6 digit code that was sent to <u>{email && email.length > 0 ? email : 'your email.'}</u>
        </Text>
        <View
          style={{
            maxWidth: maxWidth,
            alignSelf: 'center',
            marginVertical: 30,
          }}
          key="ContainerView"
        >
          <View>
            <TextInput
              placeholder="Verification Code"
              value={verificationCode}
              onChangeText={onChangeVerificationCode}
              maxLength={6}
              style={{ width: 300, alignSelf: 'center' }}
            />
            <HelperText style={showFormErrors ? sc.invalidText : sc.hintText} visible={hasVerificationErrors()}>
              Verification code is 6 digits.
            </HelperText>
          </View>
          <TextButton
            onPress={() => {
              handleSubmit();
            }}
            text="Verify Email"
            textStyle={sc.buttonText}
            style={[sc.buttonWrapper, { backgroundColor: '#2364AA' }]}
            disabled={hasVerificationErrors()}
          />
          <HelperText style={sc.invalidText} visible={formErrorMessage.length > 0}>
            {formErrorMessage}
          </HelperText>
          <Text style={[sc.focusText, { fontSize: 16, textAlign: 'center' }]}>
            If you did not receive a verification code in your email click the link below to request a new one.
          </Text>
          <Text
            onPress={() => {
              handleResendCode();
            }}
            style={[sc.link, { marginTop: 10 }]}
          >
            Resend Verification Code
          </Text>
        </View>
      </View>
    </SnapCalorieSitePage>
  );
}
